import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../shared';
import { CompanyAttributes } from '../../models/company-attributes';
import { ClaimService } from '../../services/claim.service';

@Component({
    selector: 'app-company-attributes',
    template: `
        <app-panel
        title="Company Attributes"
        fxFlex="100"
        [headerLevel]="2"
        titleCollapse="Collapse Company Attributes"
        titleExpand="Expand Company Attributes"
        >
            @if (companyAttributes) {
                <div
                    class="tw-grid tw-w-full tw-grid-cols-1 tw-gap-x-8 tw-gap-y-0 md:tw-grid-cols-2 md:tw-items-start"
                    >
                    <div class="tw-flex tw-min-w-0 tw-flex-col tw-gap-y-2">
                        <app-value
                            layout="col"
                            label="Company code"
                            [value]="companyAttributes.empCompanyCode"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Transfer code"
                            [value]="companyAttributes.transferCode"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Business unit"
                            [value]="companyAttributes.businessUnit"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Bargained"
                            [value]="companyAttributes.bargained"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Responsibility"
                            [value]="companyAttributes.respCode"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Organization ID"
                            [value]="companyAttributes.orgId"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                            [preserveAcronyms]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Department ID"
                            [value]="companyAttributes.deptId"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                            [preserveAcronyms]="true"
                        ></app-value>
                    </div>
                    <div class="tw-flex tw-min-w-0 tw-flex-col tw-gap-y-2">
                        <app-value
                            layout="col"
                            label="Location code"
                            [value]="companyAttributes.locationCode"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Job code"
                            [value]="companyAttributes.jobCode"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Business unit name"
                            [value]="companyAttributes.buName"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Bargained unit"
                            [value]="companyAttributes.bargainedUnit"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Regulated"
                            [value]="regulatedDisplay"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Organization name"
                            [value]="companyAttributes.orgName"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                        <app-value
                            layout="col"
                            label="Department name"
                            [value]="companyAttributes.deptName"
                            [translationNeeded]="false"
                            [hideWhenEmpty]="true"
                            [labelSentenceCase]="true"
                        ></app-value>
                    </div>
                </div>
            }
        </app-panel>
    `,
    styles: [
    ``,
    ],
    standalone: false
})
export class CompanyAttributesPageComponent extends BaseComponent implements OnInit {
  companyAttributes: CompanyAttributes;
  regulatedDisplay: string;

  constructor(
      private route: ActivatedRoute,
      private claimService: ClaimService
  ) {
      super();
  }

  async ngOnInit(): Promise<void> {
    this.companyAttributes = await this.claimService.getCompanyAttributes();
    if (this.companyAttributes) {
        const val = this.companyAttributes.regulated;
        this.regulatedDisplay = val === 'Y' ? 'Yes' : val === 'N' ? 'No' : val;
    }
  }
}
